import { useFormContext } from "react-hook-form";
import { cn } from "@/lib/utils";

interface FieldErrorProps {
  name: string;
  className?: string;
}

/**
 * Displays inline validation errors for a form field.
 * Reads errors from the nearest FormProvider via useFormContext.
 * Supports nested paths like "driveMappings.0.mapFrom".
 */
const FieldError: React.FC<FieldErrorProps> = ({ name, className }) => {
  const {
    formState: { errors },
  } = useFormContext();

  // Navigate nested error paths (e.g. "rootCaseFolders.0.folderPath")
  const error = name
    .split(".")
    .reduce<any>((obj, key) => obj?.[key], errors);

  if (!error?.message) return null;

  return (
    <p
      data-field-error
      role="alert"
      className={cn(
        "text-sm text-destructive mt-1 scroll-mt-20",
        className,
      )}
    >
      {String(error.message)}
    </p>
  );
};

export default FieldError;
